'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Image.es.js";
const o = a.forwardRef((a$1, m) => /* @__PURE__ */ a.createElement(p, { ref: m, ...a$1, weights: e }));
o.displayName = "ImageIcon";
const I = o;
export {
  I as Image,
  o as ImageIcon
};
